// maps.js

import {config} from '../../config/app-config';
import {apiGet} from "../../utils/api";

const LOCATIONS = {
    kyiv: {
        lat: 50.4451846,
        lng: 30.5055818,
        address: "бул. Т.Шевченка, 26/4-Б",
        title: "BML Київ",
        query: "BOGOMOLETS+MEDICAL+LABORATORIES,+%D0%B1%D1%83%D0%BB%D1%8C%D0%B2%D0%B0%D1%80+%D0%A2%D0%B0%D1%80%D0%B0%D1%81%D0%B0+%D0%A8%D0%B5%D0%B2%D1%87%D0%B5%D0%BD%D0%BA%D0%B0+26,+%D0%9A%D0%B8%D1%97%D0%B2"
    },
    lviv: {
        lat: 49.8168455,
        lng: 24.0213062,
        address: "вул.Стрийська, 33",
        title: "BML Львів",
        query: "BOGOMOLETS+MEDICAL+LABORATORIES,+%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F+%D0%A1%D1%82%D1%80%D0%B8%D0%B9%D1%81%D1%8C%D0%BA%D0%B0+33,+%D0%9B%D1%8C%D0%B2%D1%96%D0%B2"
    }
};

function createEmbedIframe(apiKey, location) {
    const iframe = document.createElement('iframe');
    const src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${location.query}&zoom=17&language=uk`;
    iframe.src = src;
    iframe.style.cssText = 'width:100%;height:100%;border:none;border-radius:12px;';
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.setAttribute('title', location.title);
    return iframe;
}

export async function initGoogleMaps() {
    const kyivDiv = document.getElementById('map');
    const lvivDiv = document.getElementById('map-lviv');

    if (!kyivDiv && !lvivDiv) return;

    try {
        const mapsConfig = await apiGet(`${config.api.paths.mapsKey}`);
        const apiKey = mapsConfig?.api_key;
        if (!apiKey) throw new Error('API key not found');

        if (kyivDiv && !kyivDiv.querySelector('iframe')) {
            kyivDiv.appendChild(createEmbedIframe(apiKey, LOCATIONS.kyiv));
        }
        if (lvivDiv && !lvivDiv.querySelector('iframe')) {
            lvivDiv.appendChild(createEmbedIframe(apiKey, LOCATIONS.lviv));
        }
    } catch (error) {
        console.error('Error initializing Google Maps:', error);
        [kyivDiv, lvivDiv].forEach(div => {
            if (div) div.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#009DC9;font-size:14px;padding:20px;text-align:center;">Карта тимчасово недоступна</div>`;
        });
    }
}

export function cleanupMapUrls() {}
